import { render, staticRenderFns } from "./workSpaceTop.vue?vue&type=template&id=1ffcf8ad&scoped=true&lang=html&"
import script from "./workSpaceTop.vue?vue&type=script&lang=js&"
export * from "./workSpaceTop.vue?vue&type=script&lang=js&"
import style0 from "./workSpaceTop.vue?vue&type=style&index=0&id=1ffcf8ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffcf8ad",
  null
  
)

component.options.__file = "workSpaceTop.vue"
export default component.exports